export enum PrintJobTrigger {
  Manual = "manual",
  Manualhotkey = "manualHotkey",
  Autoscanscreenopened = "autoScanScreenOpened",
  Autoallitemsverified = "autoAllItemsVerified",
  Autopackageselected = "autoPackageSelected",
  Autolabelprinted = "autoLabelPrinted",
}
